var borders_default = {
  "borderT": "IkN4l",
  "borderB": "Cc4Xj",
  "borderL": "vvSeR",
  "borderR": "u7VC7",
  "borderColorOverride": "cLISO"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
